import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Backdrop, CircularProgress } from '@mui/material';

export default function Loader() {
  const suppliersLoading = useSelector((state) => state.organizations.loading);
  const bpLoading = useSelector((state) => state.plans.loading);
  const invoicesLoading = useSelector((state) => state.invoices.loading);
  const cnLoading = useSelector((state) => state.subscriptions.loading);
  const dnLoading = useSelector((state) => state.partners.loading);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading([suppliersLoading, bpLoading, invoicesLoading, cnLoading, dnLoading].some((loading) => loading));
  }, [suppliersLoading, bpLoading, invoicesLoading, cnLoading, dnLoading]);

  if (isLoading) {
    return (
      <Backdrop
        open={isLoading}
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
}
